// A SHOPIFY SHOP'S OWN PRODUCT RECORD, READ BY THE BROWSER. Some shops answer this server with a
// bot check and refuse its requests, but serve their product file (`/products/<handle>.js`) to
// any page that asks, cross-origin included (`access-control-allow-origin: *`). The browser is a
// real visitor, so the listing read asks it first and hands the server what it got: the title,
// the description (where the materials are written) and the pictures.
//
// Null for anything else: not a /products/ address, not a Shopify shop, refused, or not JSON.
// The server then fetches the page itself, as it always did.
export type ShopProduct = { title: string; description: string; images: unknown[] };

export async function readShopProduct(url: string): Promise<ShopProduct | null> {
  try {
    const u = new URL(url);
    const m = u.pathname.match(/^(.*\/products\/[^/]+?)\/?$/);
    if (!m) return null;
    const res = await fetch(`${u.origin}${m[1]}.js`, { credentials: 'omit' });
    if (!res.ok) return null;
    const d = await res.json();
    if (!d || typeof d !== 'object') return null;
    return {
      title: typeof d.title === 'string' ? d.title : '',
      description: typeof d.description === 'string' ? d.description : '',
      images: Array.isArray(d.images) ? d.images : [],
    };
  } catch {
    return null;
  }
}
